module.exports = __webpack_public_path__ + "img/三棱.2ccd716d.jpg";